import React, { useContext, useState, useEffect } from "react";
import { Grid } from "@mui/material";
import MDBox from "components/MDBox";
import { LoginFormContext } from "context/LoginFormContext";
import { ModalContext } from "context/ModalContext";
import { useFormik } from "formik";
import PropTypes from "prop-types";
import MDSelectBox from "components/MDSelectBox";
import { validationSchema } from "./Schemas/validation";
import { initialValues } from "./Schemas/initialValue";
import { statusData } from "helpers/constant";
import SubmitButton from "components/SubmitButton";
import MDInput from "components/MDInput";
import { DistrictContext } from "context/DistrictContext";
import { addDistrict } from "Apis/district";
import { updateDistrictApi } from "Apis/district";

const DistrictForm = ({ districtData }) => {
  const { setNotification } = useContext(LoginFormContext);
  const { editData, setEditData } = useContext(DistrictContext);
  const [status, setStatus] = useState({
    label: "Active",
    value: "1",
  });
  const { setOpen, formIsEdit } = useContext(ModalContext);

  const handleSubmit = async (values) => {
    if (!formIsEdit) {
      let response = await addDistrict(values);
      if (response?.status === 200) {
        districtData();
        setOpen(false);
        setNotification({
          color: "success",
          icon: "check",
          title: "Success",
          content: response.data.message,
          open: true,
        });
      }
    } else {
      let editData = await updateDistrictApi(values);
      if (editData?.status === 200) {
        setNotification({
          color: "success",
          icon: "check",
          title: "Success",
          content: editData.data.message,
          open: true,
        });
        setOpen(false);
        districtData();
      } else {
        setNotification({
          color: "error",
          icon: "cancel",
          title: "Error",
          content: editData.data.message,
          open: true,
        });
      }
    }
  };

  const handleStatusChange = (value) => {
    if (value) {
      formik.setFieldValue("is_active", value.value);
      setStatus(value);
    } else {
      formik.setFieldValue("is_active", null);
      setStatus(null);
    }
  };

  const formik = useFormik({
    initialValues: formIsEdit ? setEditData : initialValues,
    validationSchema: validationSchema,
    onSubmit: handleSubmit,
  });

  // set data in formik
  const setDataInFormik = async () => {
    formik.setValues(editData);
  };

  const getStatusLabel = (id) => {
    const status = statusData.find((item) => item.value == id);
    return status ? status.label : "-";
  };

  useEffect(() => {
    if (formIsEdit) {
      setDataInFormik();
      setStatus({ label: getStatusLabel(editData?.is_active), value: editData?.is_active });
    }
  }, []);

  return (
    <MDBox>
      <MDBox component="form" role="form" onSubmit={formik.handleSubmit}>
        <Grid container spacing={2} rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
          <Grid item xs={12} md={6} sx={{ paddingTop: "25px !important" }}>
            <MDInput
              type="text"
              name="name"
              value={formik.values.name}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              label="District Name"
              sx={{ width: "100%" }}
              variant="standard"
              required
            />
            {formik.touched.name && formik.errors.name && (
              <MDBox sx={{ fontSize: "12px", color: "red", marginTop: "5px" }}>
                {formik.errors.name}
              </MDBox>
            )}
          </Grid>
          {/* status */}
          <Grid item xs={12} md={6} sx={{ paddingTop: "25px !important" }}>
            <MDSelectBox
              name="is_active"
              defaultValue={status}
              options={statusData}
              handleChange={(value) => handleStatusChange(value)}
              label="Status"
              width="100%"
              multiple={false}
              onBlur={formik.handleBlur}
              required
            />
            {formik.touched.is_active && formik.errors.is_active && (
              <MDBox sx={{ fontSize: "12px", color: "red", marginTop: "5px" }}>
                {formik.errors.is_active}
              </MDBox>
            )}
          </Grid>
        </Grid>
        <MDBox sx={{ width: "100%", textAlign: "center", marginTop: "20px" }}>
          <SubmitButton btnText={formIsEdit ? "Update" : "Add"} type="submit" />
        </MDBox>
      </MDBox>
    </MDBox>
  );
};
DistrictForm.propTypes = {
  districtData: PropTypes.func,
};
export default DistrictForm;
